import script from "./PersonalCardComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./PersonalCardComponent.vue?vue&type=script&setup=true&lang=ts"

import "./PersonalCardComponent.vue?vue&type=style&index=0&id=10be0035&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10be0035"]])

export default __exports__